import React, { Component } from 'react';
import styleable from 'react-styleable';
import Isvg from 'react-inlinesvg';
import Star from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_star.svg';
import css from './activity-status-bar.scss';
import { activityMasteryPropType } from './activity-mastery-prop-type';

const MIN_WIDTH = 15;
const INCREMENT_WIDTH_ABOVE_NUM_DIGITS = 2;
const WIDTH_INCREMENT = 8;

/**
 * ActivityStatusBar component - displays activity status bar
 * Takes activityMastery param to draw the horizontal score band
 */
class ActivityStatusBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minMasteredBandWidth: null
        };
    }

    componentDidMount() {
        this.calculateMinWidth(this.props);
    }

    componentWillReceiveProps(newProps) {
        this.calculateMinWidth(newProps);
    }

    calculateMinWidth(props) {
        const numDigits = `${props.activityMastery.goldBars}`.length;
        let minMasteredBandWidth = MIN_WIDTH;
        if (numDigits > INCREMENT_WIDTH_ABOVE_NUM_DIGITS) {
            minMasteredBandWidth += (numDigits - 2) * WIDTH_INCREMENT;
        }
        this.setState({
            minMasteredBandWidth
        });
    }

    calculateWidth = (bandScore) => {
        const { activityMastery } = this.props;
        return Math.round((bandScore / activityMastery.totalActivities) * 100);
    };

    renderMasteredBand = () => {
        const { goldBars, scoreBand } = this.props.activityMastery;
        const { minMasteredBandWidth } = this.state;
        if (scoreBand.mastered > 0) {
            const width = this.calculateWidth(scoreBand.mastered);
            return (
                <div
                    className={css.mastered}
                    style={{
                        width: `${width}%`,
                        minWidth: `${minMasteredBandWidth}px`
                    }}
                >
                    {goldBars > 0 && this.renderGold()}
                </div>
            );
        }
        return null;
    };

    renderGold = () => {
        const { goldBars } = this.props.activityMastery;
        return (
            <div>
                <div className={css.icon}>
                    <Isvg src={Star} cacheGetRequests />
                </div>
                <div className={css['gold-bars']}>{goldBars}</div>
            </div>
        );
    };

    renderScorebands = () => {
        const { activityMastery } = this.props;
        const scoreBands = [
            'consolidating',
            'developing',
            'emerging',
            'needsImproving'
        ];
        return scoreBands.map((val) => {
            const scoreBandVal = activityMastery.scoreBand[val];
            if (scoreBandVal > 0) {
                const width = this.calculateWidth(scoreBandVal);
                return (
                    <div
                        className={`${css[val]} ${css['score-band']}`}
                        style={{ width: `${width}%` }}
                        key={val}
                    />
                );
            }
            return null;
        });
    };

    render() {
        if (!this.props.activityMastery.scoreBand) {
            return null;
        }

        return (
            <div className={css['activity-mastery-container']}>
                <div className={css['activity-mastery']}>
                    {this.renderMasteredBand()}
                    {this.renderScorebands()}
                </div>
            </div>
        );
    }
}

ActivityStatusBar.propTypes = {
    activityMastery: activityMasteryPropType
};

export default styleable(css)(ActivityStatusBar);



// WEBPACK FOOTER //
// ./components/activity-status-bar/activity-status-bar.js